import { inject, Injectable, signal } from '@angular/core';
import { GuidHelpers } from '../helpers/guidHelpers';
import { IHttpVariables } from './IHttpVariables.services';
import { RuntimeProfileService } from './RuntimeProfileService';
import { PlatformLocation } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class MatwinsVariablesService implements IHttpVariables {
  private static readonly CLIENT_ID_STORAGE_KEY = 'matwins.clientId';
  private static readonly POS_BY_CLIENT_STORAGE_KEY = 'matwins.posByClient';

  //utilisé pour identifier le responsable des actions dans les websockets
  browserId: string | undefined;
  clientId?: string | null;
  posId?: number | null;
  ckeckOperation?: 'checkin' | 'checkout' | 'edit';
  currentEntityId?: number | string | null;
  dictionnaryIds: { [key: string]: string } = {};
  // Profil "local" = pas d'authentification ; lu a la volee pour ne pas dependre de l'ordre de construction.
  get useAuthentication(): boolean {
    return !this.runtimeProfile.skipsAuthentication;
  }
  variablesChanged$ = signal<void>(undefined);
  accessTokenChanged$ = signal<string>('');
  domainMatwins: string = '';
  urlMatwins: string = '';

  // vecteur d'override de tenant-prefix (utile pour le role MatwinsAdmin)
  tenantPrefix: any = null;
  tenantPrefixChanged$ = signal<any>(null);
  constructor(private platformLocation: PlatformLocation, private runtimeProfile: RuntimeProfileService) {
    this.initDomainMatwins();
    this.initUseAuthentication();
    this.clientId = this.readSavedClientId();
  }

  private initDomainMatwins(): void {
    this.setDomainFromUrl();
    // Émettre l'événement de changement
    this.variablesChanged$.set(undefined);
  }


  setClientId(id: string | null) {
    this.clientId = id;
    this.saveClientId(id);
    this.variablesChanged$.set(undefined);
  }

  setPosId(id: number | null) {
    this.posId = id;
    if (id != null && this.clientId) {
      this.savePosIdForClient(this.clientId, id);
    }
    try {
      this.variablesChanged$.set(undefined);
    } catch (e) {
      console.warn("Erreur de changement de POS ->", e)
    }
    finally {
      return;
    }
  }

  getSavedPosId(clientId: string | null | undefined): number | null {
    if (!clientId) return null;
    const id = this.readPosByClientMap()[clientId];
    return typeof id === 'number' ? id : null;
  }

  private readSavedClientId(): string | null {
    try {
      return localStorage.getItem(MatwinsVariablesService.CLIENT_ID_STORAGE_KEY);
    } catch {
      return null;
    }
  }

  private saveClientId(id: string | null): void {
    try {
      if (id) {
        localStorage.setItem(MatwinsVariablesService.CLIENT_ID_STORAGE_KEY, id);
      } else {
        localStorage.removeItem(MatwinsVariablesService.CLIENT_ID_STORAGE_KEY);
      }
    } catch { }
  }

  private readPosByClientMap(): Record<string, number> {
    try {
      const raw = localStorage.getItem(MatwinsVariablesService.POS_BY_CLIENT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  private savePosIdForClient(clientId: string, posId: number): void {
    try {
      const map = this.readPosByClientMap();
      if (map[clientId] === posId) return;
      map[clientId] = posId;
      localStorage.setItem(MatwinsVariablesService.POS_BY_CLIENT_STORAGE_KEY, JSON.stringify(map));
    } catch { }
  }

  /**
   * Récupère le domaine à partir de l'URL courante
   * @returns Le nom de domaine (sans http:// ou https://)
   */
  private setDomainFromUrl(): void {
    try {
      // Obtient l'URL complète
      const fullUrl = (this.platformLocation as any)?.location?.href || window.location.href;

      // Crée un objet URL pour faciliter l'extraction
      const url = new URL(fullUrl);

      // Retourne le hostname (sans le port)
      this.domainMatwins = url.hostname;
      if (url.port != '443' && url.port != '80' && url.port != '')
        this.domainMatwins += ':' + url.port;
      this.urlMatwins = url.origin;
    } catch (e) {
      console.error('Erreur lors de la récupération du domaine :', e);
      this.domainMatwins = '';
      this.urlMatwins = '';
    }
  }

  public getAccessToken(): string {
    return this.accessTokenChanged$();
  }

  public initUseAuthentication(): void {
    this.variablesChanged$.set(undefined);
  }

  initBrowserId() {
    const browserId = sessionStorage.getItem('browserId');

    if (browserId != undefined && browserId != null && browserId != '') {
      this.browserId = browserId;
    }
    else {
      this.browserId = GuidHelpers.generateGuid();
      sessionStorage.setItem('browserId', this.browserId);
    }
    this.variablesChanged$.set(undefined);

  }
  setDictionnaryId(componentName: string): string {
    const id = GuidHelpers.generateGuid();

    this.dictionnaryIds[componentName] = id;
    this.variablesChanged$.set(undefined);
    return id;
  }
}
